import React from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';

interface IProps {
	/** PostHog feature flag controlling the swap (e.g. 'paynow-remote-enabled'). */
	flag: string;
	/** Local override for environments without the flag (e.g. import.meta.env.VITE_PAYNOW_REMOTE_FORCE === 'true'). */
	force?: boolean;
	/** Rendered when the flag is on — the Module Federation gateway. */
	remote: React.ReactNode;
	/** Rendered when the flag is off or still bootstrapping — the existing local pages. */
	local: React.ReactNode;
}

/**
 * Flag-gated in-place route swap (strangler fig). Defaults to the LOCAL pages
 * while PostHog flags are still loading (useFeatureFlagEnabled returns
 * undefined), so the worst case is today's behaviour. Turning the flag off is
 * an instant, no-deploy rollback.
 */
const RemoteRouteSwitch: React.FC<IProps> = ({ flag, force = false, remote, local }) => {
	const flagEnabled = useFeatureFlagEnabled(flag);

	return <>{force || flagEnabled === true ? remote : local}</>;
};

export default RemoteRouteSwitch;
